"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.registerMiddleware = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    // infer the argument type so it is usable in inference down the line
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

var createDynamicMiddlewares = function createDynamicMiddlewares() {
  var middlewares = [];
  var store;

  var enhancer = function enhancer(_store) {
    store = _store;
    return function (next) {
      return function (action) {
        return compose.apply(void 0, (0, _toConsumableArray2["default"])(middlewares.map(function (m) {
          return m.middleware(store);
        })))(next)(action);
      };
    };
  };

  var registerMiddleware = function registerMiddleware(id, middleware) {
    if (middlewares.find(function (m) {
      return m.id === id;
    })) {
      return;
    }

    middlewares.push({
      id: id,
      middleware: middleware
    });
  };

  return {
    enhancer: enhancer,
    registerMiddleware: registerMiddleware
  };
};

var dynamicMiddlewaresInstance = createDynamicMiddlewares();
var registerMiddleware = dynamicMiddlewaresInstance.registerMiddleware;
exports.registerMiddleware = registerMiddleware;

var asyncMiddleware = function asyncMiddleware(store) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(action) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (action.type.includes("ERROR")) {
                  console.error(action);
                }

                if (!(typeof action.payload !== "function")) {
                  _context.next = 4;
                  break;
                }

                next(action);
                return _context.abrupt("return");

              case 4:
                store.dispatch({
                  meta: action.meta,
                  type: "".concat(action.type, "/PENDING")
                });
                _context.prev = 5;
                _context.next = 8;
                return action.payload(store.dispatch, store.getState);

              case 8:
                result = _context.sent;
                store.dispatch({
                  meta: action.meta,
                  payload: result,
                  type: "".concat(action.type, "/DONE")
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                store.dispatch({
                  ex: _context.t0,
                  meta: action.meta,
                  type: "".concat(action.type, "/ERROR")
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};

var _default = [asyncMiddleware, dynamicMiddlewaresInstance.enhancer];
exports["default"] = _default;